A human-readable name given to the profile.

This in addition to the `positionTitle` can help identify the profile to an end user.
